<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <breadCrum :breadCrumList="breadCrumList"></breadCrum>
    <div class="w80 mb-80">
        <div class="mt-30 fsb">
        <div class="content_left" style="width: 73%">
          <div class="cont_head fdc">
            <div class="cont_left" @click="onFind()">
              <img :src="detail.headUrl" alt="" />
            </div>
            <div class="cont_right">
              <div class="cont_title">
                <p>{{ detail.name }}</p>
              </div>
              <div class="fdc">
                <div class="cont_text w55">
                  <p class="cont_mater">
                    <span>就职单位 : </span>
                    <span>&nbsp;{{ detail.expertInstitution ||detail.hobby }}</span>
                  </p>
                  <p>
                    <span>擅长领域 :</span>
                    <span
                      >&nbsp;{{detail.expertDes}}</span
                    >
                  </p>
                </div>
                <div class="cont_text w40">
                  <p class="">
                    <span>提问价格：</span>
                    <span class="background">￥</span>
                    <span class="background ft22">{{
                      detail.expertQuestionPrice
                    }}</span>
                    <span>/次</span>
                  </p>
                  <p class="">
                    <span>当前位置 : </span>
                    <span v-if="detail.location">{{
                      detail.location.replace(/,/g, "/")
                    }}</span>
                  </p>
                </div>
              </div>

              <div class="fdc cont_bater">
                <user-operation
                  v-if="detail.name"
                  class="user_operation"
                  :shareObj="detail"
                  :notStatus="status"
                   @onCollection="goCollection()"
				   @callCollection="callCancelcollection()"
                ></user-operation>
                <button @click.prevent="onProp()">立即提问</button>
              </div>
            </div>
          </div>



          <div class="mt-30">
            <p class="cont_detail">专家详情</p>
            <div class="menter_content info_detail_desc" v-html="detail.detail"></div>


            <!--专家回答的问题-->
            <div class="menter_box">
               <contTitle  :obj="obj" :contTitle="contTitle"></contTitle>
               <div class="menter_message"  v-for="(item,index) in questionList" :key=index>
                  <p>问题:{{item.questionTitle}}</p>
                  <p v-if="item.createDate">回答时间:{{item.createDate.substring(0, 10)}}</p>
                  <!-- <p>提问人:{{item.username}}</p> -->
                   <p class="fac">
                     <span>提问人:</span>
                     <span class="mt-8">****</span>
                  </p>
               </div>

               <Pagination
                  v-show="total > 0"
                  :total="total"
                  :page.sync="listQuery.curPage"
                  :limit.sync="listQuery.limit"
                  @pageChange="pageChange"
                ></Pagination>
            </div>
          </div>
        </div>
        <div class="content_right" style="width: 24%">
          <newsRecommend
            :newsRecommendObj="newsRecommendObj"
            urlType="technology_detail"
            @dataRefresh="randomNewsList"
          ></newsRecommend>
          <prodSide class="mt-20" :prodSideObj="prodSideObj" @randomData="randomLessonList"></prodSide>
        </div>
        </div>
          <!--弹框-->
        <div class="expert_dialog">
          <el-dialog title="提问问题" :visible.sync="dialogFormVisible">
            <el-form :model="form" ref="form" :rules="rules">
              <el-form-item
                label="提问标题 :"
                prop="questionTitle"
                :label-width="formLabelWidth"
              >
                <el-input
                  v-model="form.questionTitle"
                  autocomplete="off"
                  style="width: 80%"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="提问价格 :" :label-width="formLabelWidth">
                <el-input
                  v-model="detail.expertQuestionPrice"
                  autocomplete="off"
                  :disabled="true"
                  style="width: 80%"
                ></el-input>
              </el-form-item>
              <div class="expery">
                <p>内容详情</p>
                <tinymceEditor
                  v-model="form.questionContent"
                  class="mt-10"
                ></tinymceEditor>
              </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button class="dialog_btn" @click.prevent="onAdd('form')"
                >确认提问</el-button
              >
              <el-button
                v-show="hide"
                class="dialog_btn"
                @click.prevent="onAmount()"
                >充值金额</el-button
              >
            </div>
          </el-dialog>
          <el-dialog :visible.sync="dialogVisible" title="余额充值"  class="recharge_dialog" append-to-body>
            <el-form :model="rulesForm" ref="rulesForm" :rules="formRules">
              <el-form-item
                label="充值金额:"
                prop="amount"
                :label-width="formLabelWidth"
              >
                <el-input
                  v-model="rulesForm.amount"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 80%"
                  type="number"
                ></el-input>
              </el-form-item>
              <el-form-item :label-width="formLabelWidth">
                <el-button
                  class="dialog_btn"
                  @click.prevent="submitAmount('rulesForm')"
                  >确认充值</el-button
                >
              </el-form-item>
            </el-form>
      </el-dialog>
        </div>
    </div>
  </div>
</template>
<script>
import {
  addProblem,
  addCollection,
  recharge,
  createorder,
  iscollection,
  cancelcollection,
  queryProblemauth
} from "@/api/coment";
import {
  getUserInfo,
  getLessonList,
  getTechnologyList,
} from "@/api/information";
import {routerGoNewpage} from "@/utils/index"
import {questionLists} from "@/api/expert"
import { getToken } from "@/utils/auth";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import newsRecommend from "../../common/newsRecommend";
import prodSide from "../../common/prodSide";
import tinymceEditor from "../../common/tinymceEditor";
import { getRandomArray } from "@/utils/index";
import userOperation from "../../common/userOperation";
import breadCrum from "@/common/breadCrum";
import contTitle from '../../common/contTitle'
import Pagination from "../../components/Pagination";
export default {
  components: {
    commBanner,
    titleHead,
    newsRecommend,
    prodSide,
    tinymceEditor,
    userOperation,
    breadCrum,
    contTitle,
    Pagination
  },
  data() {
    return {
      headTitle: "专家",
      contTitle:'回答问题',
      isShow: true,
      headText: "苏佰礼",
      obj: {
        title: "专家库",
        isShow: false,
        isExpert: false,
        roleType: "",
        personalType: 8,
      },
      newsRecommendObj: {
        title: "专家视角",
        text: "换一批",
        isImg: false,
        newData: [],
      },
      prodSideObj: {
        prodTitle: "相关视频",
        prodText: "换一批",
        isShow: false,
        prodData: [
          { content: "农村传统炉灶的改造与生物质能源清洁利用" },
          { content: "如何确保污水处理厂紫外消毒合格" },
        ],
      },
      dialogFormVisible: false, // 提问弹框
      dialogVisible: false, // 充值金额
      form: {
        questionTitle: "", //提问标题
        price: "", //价格
        questionContent: "", //内容
      },
      rules: {
        questionTitle: [
          { required: true, message: "请输入提问标题", trigger: "blur" },
        ],
      },
      rulesForm: {
        amount: "",
      },
      formRules: {
        amount: [
          { required: true, message: "请输入充值金额", trigger: "blur" },
        ],
      },
      formLabelWidth: "120px",
      id: "",
      detail: {},
      allLessonList: [],
      listQuery: {
        curPage: 1,
        limit: 10,
      },
      dataQuery:{
        curPage: 1,
        limit: 10,
        expertuserid:0
      },
      total:0,
      questionList:[],
      allNewsList: [],
      hide: false,
      status: false,
      breadCrumList: [{ name: "环保达人", url: "/expert_list" }],
      cate:'',
      msg:''
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.dataQuery.expertuserid = this.id;
    this.getDetail();
    this.getQuestionList();
    this.getRecommenedLesson();
    this.getTechnologyList();
    if (getToken() != undefined) {
      this.getIscollection();
    }
  },
  methods: {
    //获取专家视角列表
    getTechnologyList() {
      getTechnologyList({
        ...this.listQuery,
        recommend: 1,
      }).then((res) => {
        this.allNewsList = res.page.list;
        this.randomNewsList();
      });
    },
    randomNewsList() {
      this.newsRecommendObj.newData = this.getRandomList(this.allNewsList, 4);
    },
    //获取推荐课程
    getRecommenedLesson() {
      getLessonList({
        recommend: 1,
      }).then((res) => {
        this.allLessonList = res.page.list;
        this.randomLessonList();
      });
    },
    randomLessonList() {
      this.prodSideObj.prodData = this.getRandomList(this.allLessonList, 2);
    },
    getRandomList(list, length) {
      return _.compact(getRandomArray(_.cloneDeep(list), length));
    },
    //获取专家详情
    getDetail() {
      getUserInfo({
        id: this.id,
      }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data;
          this.cate = this.getCate(Number(res.data.industry));
          this.headText = this.detail.name;
          this.breadCrumList.push({name:this.detail.name})
        }
      });
    },
    //立即提问
    onProp() {
      if (getToken() != undefined) {
        if(null!=this.detail.userId && undefined!=this.detail.userId){
            let params = {'expertUserId': this.detail.userId};
            queryProblemauth(params).then((res)=>{
              if(0==res.code){
                this.dialogFormVisible = true;
              }
            }).catch((err) => {
              this.onAmount();
            });
        }
      } else {
        this.$router.push("/login");
      }
    },
    onFind() {
      this.$router.push("/expert_number");
    },
    //充值余额
    onAmount() {
      this.dialogVisible = true;
      this.dialogFormVisible = false;
    },
    //确认充值
    submitAmount(formName) {
      let url = window.location.href.split("//")[1];
      let host=window.location.host;
      let str =url.replace(host,"");
      str=str.substring(1);
      sessionStorage.setItem('url',str);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          recharge(this.rulesForm)
            .then((res) => {
              if (res.code == 0) {
                if (res.data.status == null) {
                  localStorage.setItem("list", JSON.stringify(res.data));
                  // this.$router.push({
                  //   path: "/payment",
                  // });
                   routerGoNewpage('/payment',{});
                }
                this.dialogVisible = false;
                this.hide = false;
              }
            })
            .catch((err) => {});
        } else {
          return false;
        }
      });
    },
    //添加提问
    onAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.expertUserId = this.detail.userId;
          this.form.price = this.detail.expertQuestionPrice;
          addProblem(this.form)
            .then((res) => {
              if (res.code == 0) {
                this.msg = res.msg
                this.corder(Number(res.data.id));
              }
            })
            .catch((err) => {
              this.hide = true;
            });
        } else {
          return false;
        }
      });
    },
    corder(goodsid) {
      let postdata = {
        goodsType: 5,
        goodsId: Number(goodsid),
        amount: Number(this.detail.expertQuestionPrice),
      };
      createorder(postdata).then((res) => {
        if (0 == res.code) {
          if (1 == res.data.status) {
            this.$message({
              message: this.msg,
              type: "success",
              duration: 1000,
              onClose: () => {
                this.dialogFormVisible = false;
                this.$router.push('/problem')
              },
            });
          } else {
            this.$message({
              message: "已提问,未支付！",
              type: "warning",
              duration: 1000,
              onClose: () => {
                this.dialogFormVisible = false;
              },
            });
          }
        }
      });
    },
    //专家收藏
    goCollection() {
      let params = {
        goodsId: this.id,
        goodsType: 9,
      };
      addCollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "收藏成功！",
              type: "success",
              duration: 1000,
            });
          }
        })
        .catch((err) => {});
    },
	 //取消收藏
	  callCancelcollection(){
	   let params = {
	      goodsid:this.id,
	      goodstype:"9"
	   }
	   cancelcollection(params).then((res)=>{
	     if(res.code == 0){
	        this.$message({
	          type:"success",
	          message:"取消收藏"
	        })
	     }
	   }).catch((err)=>{})
	  },
    //查看收藏状态
    getIscollection() {
      let params = {
        goodsid: this.id,
        goodstype: 9,
      };
      iscollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.status = res.data;
          }
        })
        .catch((err) => {});
    },
    //查询专家回答的问题
    getQuestionList(){
      questionLists(this.dataQuery).then((res)=>{
        if(res.code ==0){
            this.questionList = res.data.list;
            this.total = res.data.totalCount;
        }
      }).catch((err)=>{})
    },
    pageChange(item){
      this.dataQuery["curPage"] = item.page;
      this.dataQuery["limit"] = item.limit;
      this.getQuestionList();
    },
    getCate(id){
       return this.$store.getters.itemIndutry(id);
    }
  },

};
</script>
<style scoped>
.mt-20 {
  margin-top: 20px;
}
.mt-8{
  margin-top: 8px;
}

.ml-30 {
  margin-left: 30px;
}
.ml-20 {
  margin-left: 20px;
}
.w55{
  width: 55%;
}
.w40{
  width: 40%;
}

.mb-80 {
  margin-bottom: 80px;
}
.f1 {
  flex: 1;
}
.fsb {
  display: flex;
  justify-content: space-between;
}
.fac{
  display: flex;
  align-items: center;
}



.background {
  color: #ff7302;
}
.ft22 {
  font-size: 22px !important;
}
.cont_head {
  width: 100%;
  height: 238px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-top: 2px solid #50b035;
}
.cont_left {
  width: 139px;
  height: 136px;
  margin-left: 40px;
  border-radius: 50%;
  /* background: rgba(253, 242, 181, 1); */
  overflow: hidden;
}
.cont_left img {
  width: 100%;
  object-fit: fill;
}
.cont_right {
  flex: 1;
  margin-left: 40px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-right: 30px;
  margin-top: 20px;
}
.cont_title {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 15px;
}
.cont_title p {
  font-size: 26px;
}
.cont_text {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.cont_text p:nth-child(2) {
  font-size: 14px;
  line-height: 26px;
  margin-top: 8px;
  overflow : hidden;
  height: 50px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.cont_bater {
  margin-top: 15px;
}
.cont_bater button {
  width: 114px;
  height: 35px;
  background: #68be31;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.store {
  display: flex;
  justify-content: center;
  align-content: center;
  vertical-align: middle;
}
.store img {
  width: 19px;
  height: 18px;
}
.store span {
  margin-left: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.share img {
  width: 20px;
  height: 17px;
  vertical-align: middle;
}

.cont_detail {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.menter_content {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 23px;
  margin-top: 15px;
  height: 500px;
  overflow: auto;
}
.menter_photo {
  margin-top: 30px;
}
.menter_photo img {
  width: 100%;
  height: 346px;
}
.cont_mater {
  /* display: flex; */
  justify-content: space-between;
}
.cont_mater span:nth-child(2){
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.expert_dialog >>> .el-dialog__header {
  text-align: center;
}
.expert_dialog >>> .el-dialog__title {
  font-size: 24px;
  font-weight: 400;
  margin-top: 20px;
}
.expery {
  width: 90%;
  margin: 0 auto;
}
.dialog-footer {
  display: flex;
  margin-left: 30px;
}
.dialog_btn {
  width: 114px;
  height: 35px;
  background: #68be31;
  color: #ffffff;
  font-size: 14px;
  line-height: 1px;
  margin-right: 20px;
  border: none;
}
.dialog-footer >>> .el-button {
  border: none;
}
.mt-10 {
  margin-top: 10px;
}
/deep/.recharge_dialog{
  width: 50%;
  margin: 0 auto;
}



.menter_box{
  margin:30px 0px;
}
.menter_message{
  margin-top: 20px;
  background: #f8f8f8;
  border-radius: 3px;
  padding: 10px 10px;
}
.menter_message:hover{
   cursor: pointer;
   box-shadow: 0 0 20px #ddd;
}
.menter_message p{
  font-size: 14px;
  padding: 0px 10px;
  margin: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/view/other/expert_detail.vue